import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { generateAxiosInstanceSection } from '../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceInstitute } from '../hooks/useAuthorizedRequestForInstitute';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../components/ModalsCommonFunctions';
import { findPageNumber, searchArray, SortIcon } from '../components/Navigation';
import Pagination from '../components/Pagination';
import { GeneratePdf } from '../components/GeneratePdf';

const AppSubscribedStudents = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    let instituteMasterId = process.env.REACT_APP_REGISTER_INSTITUTE_ID;
    // let sectionMasterId = localStorage.getItem("sectionMasterId")

    const initialFormState = {
        instituteMasterId: instituteMasterId,
        subscriptionMasterId: '',
        sectionMasterId: '',
        academicYearMasterId: '',
        instituteGradeMasterId: '',
        instituteDivisionMasterId: ''
    }

    const [planList, setPlanList] = useState([])
    const [sectionList, setSectionList] = useState([]);
    const [gradeList, setGradeList] = useState([])
    const [divisionList, setDivisionList] = useState([])
    const [yearList, setYearList] = useState([])
    const [studentData, setStudentData] = useState(initialFormState)
    const [studentList, setStudentList] = useState([])

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [sectionNameSort, setSectionNameSort] = useState(null);
    const [studentUniqueIdSort, setStudentUniqueIdSort] = useState(null);
    const [studentIdSort, setStudentIdSort] = useState(null);
    const [regIdSort, setRegIdSort] = useState(null);
    const [studentNameSort, setStudentNameSort] = useState(null);
    const [academicYearSort, setAcademicYearSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = [
        "subscriptionDetails.subscriptionName",
        "studentDetails.sectionMasterDetails.sectionName",
        "studentDetails.studentId",
        "studentDetails.studentName",
        "studentDetails.academicYearMasterDetails.yearName",
        "studentDetails.instituteGradeMasterDetails.gradeName",
        "studentDetails.instituteDivisionMasterDetails.divisionName",
        "studentDetails.primaryContact",
        "studentDetails.email",
        "paymentOrderDetails.couponCodeDetails.code"
    ];


    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getSectionList();
        getPlanList();
        // getGradeList()
        // getYearList()
    }, []);

    useEffect(() => {
        getStudentList();
    }, [studentData]);

    const getStudentList = async () => {
        try {
            const response = await authorizedAxios.get(getApiUrl());
            setStudentList(response.data.result);
        } catch (error) {
            setStudentList([]);
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    }

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getStudentList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            setCurrPage(1);
            setStudentList(await searchArray("A", getApiUrl(), searchKeys, searchValue.trim()));
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(studentList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(studentList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > studentList.length) {
            endIndex = studentList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(studentList.slice(startIndex, endIndex));
    }, [studentList, currPage, itemsPerPage]);

    const getPlanList = async () => {
        try {
            const apiUrl = "/subscription";
            const response = await authorizedAxios.get(apiUrl);
            setPlanList(response.data.data);
        } catch (error) {
            const errorMsg = error?.data?.message || "Something went wrong!";
            console.log("Fetching error data: ", errorMsg);
        }
    }

    const getSectionList = () => {
        const apiUrl = `/get-section?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setSectionList(response.data.result)
            })
            .catch(error => {
                setSectionList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getApiUrl = () => {
        let apiUrl = `/get-app-subscription-complete-students?isActive=${studentData.isActive}&`;
        if (studentData.instituteMasterId !== '') {
            apiUrl += `instituteMasterId=${studentData.instituteMasterId}&`;
        }
        if (studentData.subscriptionMasterId !== '') {
            apiUrl += `subscriptionMasterId=${studentData.subscriptionMasterId}&`;
        }
        if (studentData.sectionMasterId !== '') {
            apiUrl += `sectionMasterId=${studentData.sectionMasterId}&`;
        }
        if (studentData.academicYearMasterId !== '') {
            apiUrl += `academicYearMasterId=${studentData.academicYearMasterId}&`;
        }
        if (studentData.instituteGradeMasterId !== '') {
            apiUrl += `instituteGradeMasterId=${studentData.instituteGradeMasterId}&`;
        }
        if (studentData.instituteDivisionMasterId !== '') {
            apiUrl += `instituteDivisionMasterId=${studentData.instituteDivisionMasterId}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    const getYearList = (sectionMasterId) => {
        let apiUrl = `/get-sections-academic-years?`;
        if (sectionMasterId) {
            apiUrl += `sectionMasterId=${sectionMasterId}`;
        }
        apiUrl = apiUrl.replace(/&$/, '');
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setYearList(response.data.data)
            })
            .catch(error => {
                setYearList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getGradeList = (sectionMasterId) => {
        const apiUrl = `/get-app-register-section-grades?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setGradeList(response.data.result)
            })
            .catch(error => {
                setGradeList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e) => {
        setStudentData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const handleSectionChange = (e) => {
        const { name, value } = e.target;
        setStudentData((prevData) => {
            return {
                ...prevData,
                [name]: value,
                instituteDivisionMasterId: '',
            }
        });

        getYearList(value);
        getGradeList(value);
    }

    const handleGradeChange = (e) => {
        const { name, value } = e.target;
        setStudentData((prevData) => {
            return {
                ...prevData,
                instituteDivisionMasterId: '',
                [name]: value
            }
        })

        const apiUrl = `/grade-wise-division?instituteMasterId=${instituteMasterId}&instituteGradeMasterId=${value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setDivisionList(response.data.result);
            })
            .catch(error => {
                setDivisionList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputReset = () => {
        setStudentData(initialFormState)
        setStudentList([])

        setSectionNameSort(null);
        setStudentUniqueIdSort(null);
        setStudentIdSort(null);
        setRegIdSort(null);
        setStudentNameSort(null);
        setAcademicYearSort(null);
    }


    useEffect(() => {
        if (sectionNameSort == true || sectionNameSort == false) {
            setStudentUniqueIdSort(null);
            setStudentIdSort(null);
            setRegIdSort(null);
            setStudentNameSort(null);
            setAcademicYearSort(null);
        }
    }, [sectionNameSort])

    useEffect(() => {
        if (studentUniqueIdSort == true || studentUniqueIdSort == false) {
            setSectionNameSort(null);
            setStudentIdSort(null);
            setRegIdSort(null);
            setStudentNameSort(null);
            setAcademicYearSort(null);
        }
    }, [studentUniqueIdSort])

    useEffect(() => {
        if (studentIdSort == true || studentIdSort == false) {
            setSectionNameSort(null);
            setStudentUniqueIdSort(null);
            setRegIdSort(null);
            setStudentNameSort(null);
            setAcademicYearSort(null);
        }
    }, [studentIdSort])

    useEffect(() => {
        if (regIdSort == true || regIdSort == false) {
            setSectionNameSort(null);
            setStudentUniqueIdSort(null);
            setStudentIdSort(null);
            setStudentNameSort(null);
            setAcademicYearSort(null);
        }
    }, [regIdSort])

    useEffect(() => {
        if (studentNameSort == true || studentNameSort == false) {
            setSectionNameSort(null);
            setStudentUniqueIdSort(null);
            setStudentIdSort(null);
            setRegIdSort(null);
            setAcademicYearSort(null);
        }
    }, [studentNameSort])

    useEffect(() => {
        if (academicYearSort == true || academicYearSort == false) {
            setSectionNameSort(null);
            setStudentUniqueIdSort(null);
            setStudentIdSort(null);
            setRegIdSort(null);
            setStudentNameSort(null);
        }
    }, [academicYearSort])


    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>App Subscribed Students</span></li>
                        </ol>
                    </nav>
                </div>

                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-users-line"></i>App Subscribed Students</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="subscriptionMasterId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subscription Plan :</label>
                                                    <select class="form-select" aria-label="Default select example" name='subscriptionMasterId' onChange={handleInputChange} value={studentData.subscriptionMasterId}>
                                                        <option selected value={''} disabled>Select Subscription Plan</option>
                                                        {
                                                            planList?.map((plan) => {
                                                                if (plan.length !== 0 && plan?.id !== 4) {
                                                                    return <option value={plan.id}>{plan.subscriptionName}</option>
                                                                }
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="sectionMasterId" className="col-form-label">Select Section</label>
                                                    <select class="form-select" aria-label="Default select example" name='sectionMasterId' onChange={handleSectionChange} value={studentData.sectionMasterId} >
                                                        <option selected value={''} disabled>Select Section</option>
                                                        {
                                                            sectionList?.map((section) => {
                                                                return <option value={section.id}>{section.sectionName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Academic Year :</label>
                                                    <select class="form-select" aria-label="Default select example" name='academicYearMasterId' onChange={handleInputChange} value={studentData.academicYearMasterId}>
                                                        <option selected value={''} disabled>Select Academic Year</option>
                                                        {
                                                            yearList?.map((list) => {
                                                                return <option value={list?.academicYearMasterDetails?.id}>{list?.academicYearMasterDetails?.yearName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Class :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteGradeMasterId' onChange={handleGradeChange} value={studentData.instituteGradeMasterId}>
                                                        <option selected value={''} disabled>Select Class</option>
                                                        {
                                                            gradeList?.map((grade) => {
                                                                return <option value={grade.instituteGradeMasterId}>{grade.instituteGradeMasterDetails.gradeName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Division :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteDivisionMasterId' onChange={handleInputChange} value={studentData.instituteDivisionMasterId}>
                                                        <option selected value={''} disabled>Select Division</option>
                                                        {
                                                            divisionList?.map((division) => {
                                                                return <option value={division.id}>{division.divisionName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        <button className="btn btn-danger delete_icon" type="button" style={{ marginRight: "20px" }} onClick={handleInputReset}>Reset</button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        {studentList && studentList.length > 0 && <GeneratePdf id="appSubscribedStudent" title={studentList} headerTitle={"App Subscribed Student"} />}
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table" id='appSubscribedStudent'>
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope='col'>Current Subscription</th>
                                                                        <th scope='col'>
                                                                            Section Name
                                                                            <SortIcon sortState={sectionNameSort} setSortState={setSectionNameSort} setData={setStudentList} setCurrPage={setCurrPage} sortingPath={"studentDetails.sectionMasterDetails.sectionName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            User Name
                                                                            <SortIcon sortState={studentUniqueIdSort} setSortState={setStudentUniqueIdSort} setData={setStudentList} setCurrPage={setCurrPage} sortingPath={"studentDetails.studentId"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Name
                                                                            <SortIcon sortState={studentNameSort} setSortState={setStudentNameSort} setData={setStudentList} setCurrPage={setCurrPage} sortingPath={"studentDetails.studentName"} />
                                                                        </th>
                                                                        <th scope='col'>
                                                                            Academic Year
                                                                            <SortIcon sortState={academicYearSort} setSortState={setAcademicYearSort} setData={setStudentList} setCurrPage={setCurrPage} sortingPath={"studentDetails.academicYearMasterDetails.yearName"} />
                                                                        </th>
                                                                        <th scope='col'>
                                                                            Class
                                                                        </th>
                                                                        <th scope='col'>
                                                                            Division
                                                                        </th>
                                                                        <th scope="col">Phone No</th>
                                                                        <th scope="col">Email</th>
                                                                        <th scope="col">Coupon Code</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData?.length > 0 ?
                                                                            displayedData?.map((std, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{std?.subscriptionDetails?.subscriptionName}</td>
                                                                                        <td>{std?.studentDetails?.sectionMasterDetails?.sectionName}</td>
                                                                                        <td>{std?.studentDetails?.studentId}</td>
                                                                                        <td>{std?.studentDetails?.studentName}</td>
                                                                                        <td>{std?.studentDetails?.academicYearMasterDetails?.yearName}</td>
                                                                                        <td>{std?.studentDetails?.instituteGradeMasterDetails?.gradeName}</td>
                                                                                        <td>{std?.studentDetails?.instituteDivisionMasterDetails?.divisionName}</td>
                                                                                        <td>{std?.studentDetails?.primaryContact}</td>
                                                                                        <td>{std?.studentDetails?.email}</td>
                                                                                        <td>{std?.paymentOrderDetails[0]?.couponCodeDetails?.code}</td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Students Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={studentList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default AppSubscribedStudents
